import { Star } from "lucide-react";
import { Check } from "lucide-react";
import { Reveal } from "../motion/Reveal";
import { testimonials } from "../../data/academyData";

export const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="relative py-20 md:py-32 bg-[#0A0A0D] border-t border-white/[0.06]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-amber-400 font-semibold mb-4">What Members Are Saying</p>
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-semibold text-white max-w-2xl leading-tight">Real Members. Real Transformation.</h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="testimonials-carousel">
        {testimonials.map((t, i) => (
          <Reveal key={t.name} delay={(i % 3) * 0.08}>
            <div className="rounded-2xl bg-white/[0.03] border border-white/10 p-6 sm:p-8 h-full flex flex-col">
              <div className="flex items-center gap-3 mb-4">
                <img src={t.avatar} alt={`${t.name}, AX Academy member`} className="h-11 w-11 rounded-full object-cover border border-rose-500/30" />
                <div>
                  <p className="text-sm text-white font-semibold">{t.name}</p>
                  <p className="text-xs text-zinc-500 font-mono">{t.location}</p>
                  <p className="mt-0.5 flex items-center gap-1 text-[11px] text-emerald-400 font-medium" data-testid={`testimonial-verified-badge-${i}`}>
                    <Check size={11} /> Verified Member
                  </p>
                </div>
              </div>
              <div className="flex gap-1 text-amber-400 mb-4">
                {Array.from({ length: 5 }).map((_, si) => (
                  <Star key={si} size={15} className="fill-amber-400" />
                ))}
              </div>
              <p className="text-zinc-300 leading-relaxed flex-1">"{t.quote}"</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
